import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Cities() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("cities.title", "Browse Events by City")}
      subtitle={t("cities.subtitle", "Coming Soon")}
    >
      <div className="space-y-8">
        <div className="rounded-lg border border-blue-700/50 bg-blue-900/30 p-8 text-center">
          <div className="mb-4 text-4xl">🌍</div>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("cities.comingSoonTitle", "City Guides Coming Soon")}
          </h2>
          <p className="mb-6 text-slate-300">
            {t(
              "cities.comingSoonText",
              "We're currently building dedicated city guides to help you discover the best events happening in your area."
            )}
          </p>
          <p className="mb-8 text-slate-400">
            {t("cities.soonText", "Soon you'll be able to explore:")}
          </p>
          <ul className="mb-8 inline-flex flex-wrap justify-center gap-4">
            {[
              ["localEventHubs", "📍 Local Event Hubs"],
              ["musicVenues", "🎵 Music Venues"],
              ["cultureArts", "🎭 Culture & Arts"],
              ["nightlife", "🎉 Nightlife"],
            ].map(([key, fallback]) => (
              <li key={key} className="rounded-full border border-slate-700 bg-slate-800/50 px-4 py-2 text-slate-300">
                {t(`cities.items.${key}`, fallback)}
              </li>
            ))}
          </ul>
          <p className="text-sm text-slate-400">
            {t("cities.followText", "Check back soon or follow our social media for updates!")}
          </p>
        </div>
      </div>
    </PageLayout>
  );
}

export default Cities;
